module.exports = __webpack_public_path__ + "img/logo.532b44f2.svg";